var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.showAddDocumentModal },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "PlusIcon" },
                          }),
                          _vm._v(" New Document "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            { staticClass: "d-inline-block text-sm-left mr-1" },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            staticClass: "w-75",
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            label: "Filter",
                            "label-cols-sm": "3",
                            "label-align-sm": "right",
                            "label-size": "sm",
                            "label-for": "filterInput",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            { attrs: { size: "sm" } },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "filterInput",
                                  type: "search",
                                  placeholder: "Type to Search",
                                },
                                model: {
                                  value: _vm.filter,
                                  callback: function ($$v) {
                                    _vm.filter = $$v
                                  },
                                  expression: "filter",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { disabled: !_vm.filter },
                                      on: {
                                        click: function ($event) {
                                          _vm.filter = ""
                                        },
                                      },
                                    },
                                    [_vm._v(" Clear ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                          items: _vm.documents,
                          fields: _vm.documentFields,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(status)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant:
                                        _vm.statusVariants[data.item.status],
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.statusText[data.item.status]
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(issueDate)",
                            fn: function (data) {
                              return [
                                data.item.issueDate
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatissueDate(
                                              data.item.issueDate
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                          {
                            key: "cell(expiryDate)",
                            fn: function (data) {
                              return [
                                _vm.isExpired(data.item.expiryDate)
                                  ? _c(
                                      "b-badge",
                                      { attrs: { variant: "danger" } },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatexpiryDate(
                                                data.item.expiryDate
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _c("span", [_vm._v(" - ")]),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "p-0",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "align-middle text-body",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.showViewDocumentModal(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EyeIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("View")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        directives: [
                                          {
                                            name: "b-modal",
                                            rawName:
                                              "v-b-modal.modalEditDocument",
                                            modifiers: {
                                              modalEditDocument: true,
                                            },
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.showEditDocumentModal(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EditIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("Edit")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmDeleteDocument(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "TrashIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("Delete")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modalAddDocument",
          attrs: {
            id: "modal-add-document",
            title: "Add New Document",
            centered: "",
            "hide-footer": "",
          },
        },
        [
          _c("validation-observer", {
            ref: "AddDocumentForm",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var invalid = ref.invalid
                  var handleSubmit = ref.handleSubmit
                  return [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return handleSubmit(_vm.addNewDocument)
                          },
                        },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Name",
                                      "label-for": "documentName",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Document Name",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "documentName" },
                                                  model: {
                                                    value:
                                                      _vm.newDocument
                                                        .documentName,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newDocument,
                                                        "documentName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newDocument.documentName",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Description",
                                      "label-for": "documentDescription",
                                    },
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { id: "documentDescription" },
                                      model: {
                                        value: _vm.newDocument.notes,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.newDocument,
                                            "notes",
                                            $$v
                                          )
                                        },
                                        expression: "newDocument.notes",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Type",
                                      "label-for": "documentType",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Document Type",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    id: "documentType",
                                                    options: _vm.documentType,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newDocument
                                                        .documentType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newDocument,
                                                        "documentType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newDocument.documentType",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Issue Date",
                                      "label-for": "issueDate",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: { name: "Issue Date" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-datepicker", {
                                                  attrs: { id: "issueDate" },
                                                  model: {
                                                    value:
                                                      _vm.newDocument.issueDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newDocument,
                                                        "issueDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newDocument.issueDate",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Expiry Date",
                                      "label-for": "expiryDate",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Expiry Date",
                                        rules: {
                                          required: false,
                                          dateAfter: _vm.newDocument.issueDate,
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-datepicker", {
                                                  attrs: { id: "expiryDate" },
                                                  model: {
                                                    value:
                                                      _vm.newDocument
                                                        .expiryDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newDocument,
                                                        "expiryDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newDocument.expiryDate",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Status",
                                      "label-for": "status",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Status",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    id: "status",
                                                    options: _vm.documentStatus,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newDocument.status,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newDocument,
                                                        "status",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newDocument.status",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Upload File",
                                      "label-for": "documentFile",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Document File",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center",
                                                  },
                                                  [
                                                    _c("b-form-input", {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        id: "documentFile",
                                                        readonly: "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.newDocument
                                                            .filename,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.newDocument,
                                                            "filename",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "newDocument.filename",
                                                      },
                                                    }),
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          variant: "primary",
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.openMediaDialog,
                                                        },
                                                      },
                                                      [_vm._v("Browse")]
                                                    ),
                                                    _c("input", {
                                                      ref: "mediaInput",
                                                      staticClass: "d-none",
                                                      attrs: { type: "file" },
                                                      on: {
                                                        change:
                                                          _vm.handleMediaUpload,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm.fileSizeError
                                      ? _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(_vm.fileSizeError))]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              type: "submit",
                              variant: "primary",
                              disabled: _vm.submitting,
                            },
                            on: { click: _vm.addNewDocument },
                          },
                          [
                            _vm.submitting
                              ? _c("b-spinner", { attrs: { small: "" } })
                              : _vm._e(),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.submitting ? "Adding..." : "Add Document"
                                ) +
                                " "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modalViewDocument",
          attrs: {
            title: "View Document",
            "cancel-variant": "outline-secondary",
            "hide-footer": "",
            centered: "",
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Name",
                                "label-for": "viewDocumentName",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "viewDocumentName", readonly: "" },
                                model: {
                                  value: _vm.viewDocumentData.documentName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.viewDocumentData,
                                      "documentName",
                                      $$v
                                    )
                                  },
                                  expression: "viewDocumentData.documentName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Description",
                                "label-for": "viewDocumentDescription",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "viewDocumentDescription",
                                  readonly: "",
                                },
                                model: {
                                  value: _vm.viewDocumentData.notes,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.viewDocumentData, "notes", $$v)
                                  },
                                  expression: "viewDocumentData.notes",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Type",
                                "label-for": "viewDocumentType",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "viewDocumentType", readonly: "" },
                                model: {
                                  value: _vm.viewDocumentData.documentType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.viewDocumentData,
                                      "documentType",
                                      $$v
                                    )
                                  },
                                  expression: "viewDocumentData.documentType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Issue Date",
                                "label-for": "viewIssueDate",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                attrs: {
                                  id: "viewIssueDate",
                                  type: "date",
                                  disabled: "",
                                  readonly: "",
                                },
                                model: {
                                  value: _vm.viewDocumentData.issueDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.viewDocumentData,
                                      "issueDate",
                                      $$v
                                    )
                                  },
                                  expression: "viewDocumentData.issueDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Expiry Date",
                                "label-for": "viewExpiryDate",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                attrs: {
                                  id: "viewExpiryDate",
                                  type: "date",
                                  disabled: "",
                                  readonly: "",
                                },
                                model: {
                                  value: _vm.viewDocumentData.expiryDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.viewDocumentData,
                                      "expiryDate",
                                      $$v
                                    )
                                  },
                                  expression: "viewDocumentData.expiryDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Status",
                                "label-for": "viewStatus",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "viewStatus",
                                  options: _vm.documentStatus,
                                  readonly: "",
                                },
                                model: {
                                  value: _vm.viewDocumentData.status,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.viewDocumentData,
                                      "status",
                                      $$v
                                    )
                                  },
                                  expression: "viewDocumentData.status",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modalEditDocument",
            title: "Edit Document",
            "cancel-variant": "outline-secondary",
            "hide-footer": "",
            centered: "",
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleSubmit(_vm.updateDocument)
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Name",
                                "label-for": "editDocumentName",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "editDocumentName", required: "" },
                                model: {
                                  value: _vm.editDocumentData.documentName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editDocumentData,
                                      "documentName",
                                      $$v
                                    )
                                  },
                                  expression: "editDocumentData.documentName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Description",
                                "label-for": "editDocumentDescription",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "editDocumentDescription",
                                  required: "",
                                },
                                model: {
                                  value: _vm.editDocumentData.notes,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editDocumentData, "notes", $$v)
                                  },
                                  expression: "editDocumentData.notes",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Type",
                                "label-for": "editDocumentType",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "editDocumentType",
                                  options: this.documentType,
                                  required: "",
                                },
                                model: {
                                  value: _vm.editDocumentData.documentType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editDocumentData,
                                      "documentType",
                                      $$v
                                    )
                                  },
                                  expression: "editDocumentData.documentType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Issue Date",
                                "label-for": "editIssueDate",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                attrs: {
                                  id: "editIssueDate",
                                  type: "date",
                                  required: "",
                                },
                                model: {
                                  value: _vm.editDocumentData.issueDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editDocumentData,
                                      "issueDate",
                                      $$v
                                    )
                                  },
                                  expression: "editDocumentData.issueDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Expiry Date",
                                "label-for": "expiryDate",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "Expiry Date",
                                  rules: {
                                    required: true,
                                    dateAfter: _vm.editDocumentData.issueDate,
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-datepicker", {
                                          attrs: { id: "expiryDate" },
                                          model: {
                                            value:
                                              _vm.editDocumentData.expiryDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.editDocumentData,
                                                "expiryDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "editDocumentData.expiryDate",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Status",
                                "label-for": "editStatus",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "editStatus",
                                  options: _vm.documentStatus,
                                  required: "",
                                },
                                model: {
                                  value: _vm.editDocumentData.status,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editDocumentData,
                                      "status",
                                      $$v
                                    )
                                  },
                                  expression: "editDocumentData.status",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Upload File",
                                "label-for": "editDocumentFile",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("b-form-input", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      id: "editDocumentFile",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.editDocumentData.filename,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editDocumentData,
                                          "filename",
                                          $$v
                                        )
                                      },
                                      expression: "editDocumentData.filename",
                                    },
                                  }),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "primary" },
                                      on: { click: _vm.openMediaDialog },
                                    },
                                    [_vm._v("Browse")]
                                  ),
                                  _c("input", {
                                    ref: "mediaInput",
                                    staticClass: "d-none",
                                    attrs: { type: "file" },
                                    on: { change: _vm.handleMediaUpload },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "button",
                        block: "",
                        disabled: _vm.invalid,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateDocument()
                        },
                      },
                    },
                    [_vm._v(" Update Document ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }